import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {selectSelectedFeature} from '../../../../../../features/user-access/user-stores-store/user-store.selectors';
import {Subject} from 'rxjs';
import {IFeature, ILoginSteps, LoginProgress} from '../../../../../../features/user-access/models';
import {DEFAULT_LOADER_FLASH} from '../../../../models/animations';
import {selectLoginProgress} from '../../../../../../features/user-access/user-store/user.selectors';
import {setNavigation} from '../../../../../../features/user-access/user-stores-store/user-store.actions';
import {NavigationPageEnum} from '../../../../../../features/user-access/models/navigations.enums';
import {getDeepCopyOfObject} from '../../../../../shared-utils/object/object.utils';

@Component({
    selector: 'app-shared-loading-feature-login',
    templateUrl: './shared-loading-feature-login.component.html',
    styleUrls: ['./shared-loading-feature-login.component.scss'],
    standalone: false
})
export class SharedLoadingFeatureLoginComponent implements OnInit, OnDestroy {

  #destroy$ = new Subject<boolean>();
  #loginProgress: ILoginSteps;
  #featureName = '';

  protected animation = DEFAULT_LOADER_FLASH;

  constructor(
    @Inject('SHARED_MODAL_CUSTOM_DATA') data: {},
    private readonly store: Store,
  ) {
  }

  get componentId(): string {
    return `feature-loader-${this.feature}`;
  }

  get feature(): string {
    return this.#featureName;
  }

  get isLoginError(): boolean {
    return this.loginProgress?.hasOwnProperty('error') && this.loginProgressPercentComplete === 99;
  }

  get loginProgress(): ILoginSteps {
    return this.#loginProgress;
  }

  get loginProgressPercentComplete(): number {
    return this.#loginProgress?.progress?.percentComplete || 0;
  }

  get loginTextAtCurrentStep(): string {
    const currentStep = this.loginProgress?.progress?.currentStep || 0;
    return this.loginProgress[currentStep].description || '';
  }

  set feature(feature: string) {
    this.#featureName = feature;
  }

  ngOnDestroy(): void {
    this.#destroy$.next(true);
    this.#destroy$.complete();
  }

  ngOnInit(): void {
    this.store.select(selectSelectedFeature)
      .pipe(takeUntil(this.#destroy$))
      .subscribe((feature: IFeature): void => {
        this.feature = feature.feature || 'not-set-feature';
        if (feature.feature === 'login') {
          this.store.select(selectLoginProgress)
            .pipe(takeUntil(this.#destroy$))
            .subscribe((progress: ILoginSteps): void => {
              if (progress) {
                this.setLoginProgress(progress);
              }
            });
        }
      });
  }

  private setLoginProgress(progress: ILoginSteps): void {
    if (this.isLoginError) {
      console.error(progress.error);
    }
    if (Object.keys(progress).length > 0) {
      this.#loginProgress = progress;
      if (this.loginProgressPercentComplete === 100) {
        this.store.dispatch(setNavigation({
          feature: NavigationPageEnum.Home,
          navigation: {
            currentPage: NavigationPageEnum.Home,
            currentTab: null,
          },
        }));
      }
    } else {
      this.#loginProgress = getDeepCopyOfObject(LoginProgress);
    }
  }

}
